import React from 'react';
import { getImage } from '../../../../utils/imageHelper';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import moment from 'moment';
import styles from "../../cards.module.scss"

function ResourceListItem({ resource, handleClickResource, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickResource}>
      <img
        className={styles.projectImage}
        src={resource.image ? resource.image.file : getImage('img-ph.png')}
        alt={resource.image ? resource.image.label : 'Non renseignée'}
      />

      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{resource.title}</p>
          <span className={styles.subtitle}>{resource.author}</span>
        </div>
        <div className={styles.tagList}>
          <Tag tag={getConstant('banquetceleste.common.statusTypes', resource.status)} rounded />
          <Tag tag={getConstant('banquetceleste.resourceTypes', resource.type)} rounded />
        </div>
      </div>
      {/* <p className="text-sm italic">{moment(resource.date).format('DD/MM/YYYY')}</p> */}
    </div>
  );
}

export default ResourceListItem;
